import type { AxiosResponse } from 'axios';

import { baseRoutes, baseUrl } from '@/api/config';

import axiosInstance from '../../instance';
import ROUTES from '../../routes';
import type { IIncidentType } from './types';

export const getAllIncidentTypes = (): Promise<void | AxiosResponse<IIncidentType []>> => axiosInstance({
  baseURL: `${baseUrl}${baseRoutes}`,
  url: ROUTES.INCIDENT_TYPES,
  method: 'GET',
  headers: {
    authorization: true,
  },
});
